import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  data() {
    return {
      secondsCounter: 0,
      firstPlay: false,
      updateTimeId: null,
      // updateTimeId: 'player-update-time-id',
      time_in_seconds_to_update_progress_on_server: 30,
    }
  },
  watch: {
    content(newVal, oldVal) {
      if (oldVal && newVal && newVal.id !== oldVal.id) {
        console.log('Content changed, removing old event listeners for Videohub:', oldVal.id, newVal.id);
        window.removeEventListener('message', this.handleMessage);
      }
    }
  },
  computed: {
    now(){
      return Date.now()
    },
    ...mapGetters(['content','module','selectedCycle','accessing_content','authUser']),
    minimumPercentageWatch(){
      return this.selectedCycle.is_finished ? 0 : 60
    },
  },
  created(){
    console.log('Created Videohub PlayerOptionsMixin', this.content.id);
  },
  beforeDestroy(){
    window.removeEventListener('message', this.handleMessage);
    console.log('Before Destroy Videohub PlayerOptionsMixin', this.content.id); 
  },
  destroyed(){
    console.log('Destroyed Videohub PlayerOptionsMixin', this.content.id);
    window.removeEventListener('message', this.handleMessage);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
 
  mounted(){
    this.secondsCounter = 0
      window.addEventListener('message', this.handleMessage);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
      handleMessage(event){
        
        if (event.origin !== 'https://evolucional.videohub.com.br') return;

        if (!event.data.videohub) return; 

        const { event: vh_event, data: vh_data } = event.data.videohub
        
        if(vh_event == 'timeupdate') {
         
          let seconds_watched = _.clone(this.content.seconds_watched) + 5

          if(this.secondsCounter > 0 && seconds_watched > 0) {
          
            this.updateModuleContent({
              milliseconds_watched : seconds_watched * 1000,
              seconds_watched,
              isPlaying: true,
              milliseconds_duration : Math.trunc(vh_data.duration)  * 1000,
              seconds_duration : Math.trunc(vh_data.duration),
            });
          
          }

          this.secondsCounter = this.secondsCounter + 5

          if (this.secondsCounter >= this.time_in_seconds_to_update_progress_on_server || this.content.percentage_watched >= 100) {
            this.saveContentProgress({content_id: this.content.id, seconds_duration: this.content.seconds_duration, seconds_watched })
            this.secondsCounter = 1
          }

        }
        
        if(vh_event.includes('mut')) {
            const iframe = document.querySelector("iframe[data-videohub-id]");
            if (iframe) {
              iframe.contentWindow.postMessage({ method: 'pause' }, "https://evolucional.videohub.com.br");
            }
        }
      },
      handleVisibilityChange() {
        if (document.hidden) {
           const iframe = document.querySelector("iframe[data-videohub-id]");
            if (iframe) {
              iframe.contentWindow.postMessage({ method: 'pause' }, "https://evolucional.videohub.com.br");
            }
        }
      },
      ...mapMutations(['SET_MODULE']),
      ...mapActions(['saveContentProgress']),
      updateModuleContent(content) {
         this.SET_MODULE({
              ...this.module,
              contents: this.module.contents.map(c => {
                if(c.id == this.content.id){

                  if (!c.seconds_duration || c.seconds_duration === 0) {
                    c.seconds_duration = content.seconds_duration;
                    c.milliseconds_duration = content.milliseconds_duration;
                  }
                  
                  // atualiza porcentagem assistida
                  
                  const seconds_watched = c.seconds_watched >= c.seconds_duration ? c.seconds_duration: content.seconds_watched 
                  let percentage_watched = (seconds_watched * 100) / content.seconds_duration;
                  percentage_watched = percentage_watched >= 100 ? 100 : percentage_watched

                  c.seconds_watched = content.seconds_watched
                  c.percentage_watched = Math.trunc(percentage_watched)
                  
                  // console.log('Conteúdo do vídeo percentage atualizado:', videoContent, percentage_watched);
                  // atualiza liberação do vídeo para conclusão
                  // se a porcentagem assistida for maior ou igual a 60% ou o ciclo selecionado já estiver finalizado
                  // libera o vídeo para conclusão
                  
                  let released_to_finish = (this.content.percentage_watched >= this.minimumPercentageWatch) || this.selectedCycle.is_finished ? true : false

                  let left_seconds = this.content.seconds_duration && this.content.seconds_duration > 0 ? this.content.seconds_duration - this.content.seconds_watched : 300
                  c.released_to_finish = released_to_finish
                  c.left_seconds = released_to_finish ? 0 : left_seconds

                  return c
                }
                
                return c
              })
            })
      }
      
    }
}